"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var vee_validate_1 = require("vee-validate");
var zip_utils_1 = __importDefault(require("../../utils/zip_utils"));
var data_parser_1 = __importDefault(require("../../../common/src/utils/validation/data_parser"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var Autokana = require('vanilla-autokana');
var OfficeInfo = /** @class */ (function (_super) {
    __extends(OfficeInfo, _super);
    function OfficeInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            requestEmail: _this.email,
            requestPersonLastName: '',
            requestPersonFirstName: '',
            requestPersonKanaLastName: '',
            requestPersonKanaFirstName: '',
            officeNo: '',
            companyName: '',
            companyNameKana: '',
            officeName: '',
            officeNameKana: '',
            zip1: '',
            zip2: '',
            address1: '',
            address2: '',
            address3: '',
            corporateName: '',
            companyNo: '',
            corporateZip1: '',
            corporateZip2: '',
            corporateAddress1: '',
            corporateAddress2: '',
            corporateAddress3: '',
            tel: '',
            tantosyaLastName: '',
            tantosyaFirstName: '',
            tantosyaKanaLastName: '',
            tantosyaKanaFirstName: '',
            tantosyaMail: ''
        };
        _this.setUpComplete = false;
        _this.isEkyc = false;
        return _this;
    }
    OfficeInfo.prototype.refs = function () {
        return this.$refs;
    };
    OfficeInfo.prototype.isEkycCheck = function (value) {
        this.isEkyc = value;
    };
    OfficeInfo.prototype.setData = function (data) {
        var self_ = this;
        Object.keys(this.form).forEach(function (key) {
            self_.form[key] = data[key];
            if (self_.form[key]) {
                self_.form[key] = self_.form[key].trim();
            }
        });
        this.setUpComplete = true;
    };
    OfficeInfo.prototype.getSelectPlaceHolder = function () {
        if (!this.setUpComplete) {
            return;
        }
        if (value_checker_1.default.isBlank(this.form.address1)) {
            return this.$t('view.contract_form.update.placeholder.office_info.address_1');
        }
        else if (this.isEkyc && value_checker_1.default.isBlank(this.form.corporateAddress1)) {
            return this.$t('view.contract_form.update.placeholder.office_info.corporate_address_1');
        }
        return "";
    };
    OfficeInfo.prototype.getCorporateSelectPlaceHolder = function () {
        if (!this.setUpComplete) {
            return;
        }
        if (value_checker_1.default.isBlank(this.form.corporateAddress1)) {
            return this.$t('view.contract_form.update.placeholder.office_info.corporate_address_1');
        }
        return "";
    };
    OfficeInfo.prototype.emailChange = function () {
        this.form.requestEmail = this.email;
    };
    OfficeInfo.prototype.corporateZipChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCorporateJusyo()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OfficeInfo.prototype.getCorporateJusyo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var zipcode, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        zipcode = String(this.form.corporateZip1) + String(this.form.corporateZip2);
                        if (!zip_utils_1.default.isValid(zipcode)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, zip_utils_1.default.getAddress(zipcode)];
                    case 1:
                        res = _a.sent();
                        this.form.corporateAddress1 = res['address1'];
                        this.form.corporateAddress2 = res['address2'];
                        if (res['address3']) {
                            this.form.corporateAddress2 = res['address2'] + " " + res['address3'];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OfficeInfo.prototype.zipChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJusyo()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OfficeInfo.prototype.getJusyo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var zipcode, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        zipcode = String(this.form.zip1) + String(this.form.zip2);
                        if (!zip_utils_1.default.isValid(zipcode)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, zip_utils_1.default.getAddress(zipcode)];
                    case 1:
                        res = _a.sent();
                        this.form.address1 = res['address1'];
                        this.form.address2 = res['address2'];
                        if (res['address3']) {
                            this.form.address2 = res['address2'] + " " + res['address3'];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OfficeInfo.prototype.mounted = function () {
        this.requestPersonLastNameAutokana = this.bundAutokana("#office_info_request_person_last_name", "#office_info_request_person_kana_last_name");
        this.requestPersonFirstNameAutokana = this.bundAutokana("#office_info_request_person_first_name", "#office_info_request_person_kana_first_name");
        this.officeNameAutokana = this.bundAutokana("#office_info_office_name", "#office_info_office_name_kana");
        this.tantosyaLastNameAutokana = this.bundAutokana("#office_info_tantosya_last_name", "#office_info_tantosya_kana_last_name");
        this.tantosyaFirstNameAutokana = this.bundAutokana("#office_info_tantosya_first_name", "#office_info_tantosya_kana_first_name");
    };
    OfficeInfo.prototype.bundAutokana = function (from, to) {
        return Autokana.bind(from, to, { katakana: true });
    };
    OfficeInfo.prototype.handleAautokana = function (target, autokana) {
        this.form[target] = this[autokana].getFurigana();
    };
    OfficeInfo.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var hasError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.refs().inputObserver.validate()];
                    case 1:
                        hasError = !(_a.sent());
                        if (hasError) {
                            this.$emit('error-occured');
                            return [2 /*return*/];
                        }
                        this.$emit('error-fixed');
                        this.form.companyName = data_parser_1.default.parseCompanyName(this.form.companyName);
                        this.form.officeName = data_parser_1.default.parseCompanyName(this.form.officeName);
                        this.form.requestPersonKanaLastName = data_parser_1.default.parseKatakana(this.form.requestPersonKanaLastName);
                        this.form.requestPersonKanaFirstName = data_parser_1.default.parseKatakana(this.form.requestPersonKanaFirstName);
                        this.form.tantosyaKanaLastName = data_parser_1.default.parseKatakana(this.form.tantosyaKanaLastName);
                        this.form.tantosyaKanaFirstName = data_parser_1.default.parseKatakana(this.form.tantosyaKanaFirstName);
                        this.form.companyNameKana = data_parser_1.default.parseKatakana(this.form.companyNameKana);
                        this.form.officeNameKana = data_parser_1.default.parseKatakana(this.form.officeNameKana);
                        this.form.zip1 = data_parser_1.default.toHankaku(this.form.zip1);
                        this.form.zip2 = data_parser_1.default.toHankaku(this.form.zip2);
                        this.form.address1 = data_parser_1.default.toHankaku(this.form.address1);
                        this.form.address2 = data_parser_1.default.toHankaku(this.form.address2);
                        this.form.address3 = data_parser_1.default.toHankaku(this.form.address3);
                        if (this.isEkyc) {
                            this.form.corporateName = data_parser_1.default.parseCompanyName(this.form.corporateName);
                            this.form.companyNo = data_parser_1.default.toHankaku(this.form.companyNo);
                            this.form.corporateZip1 = data_parser_1.default.toHankaku(this.form.corporateZip1);
                            this.form.corporateZip2 = data_parser_1.default.toHankaku(this.form.corporateZip2);
                            this.form.corporateAddress1 = data_parser_1.default.toHankaku(this.form.corporateAddress1);
                            this.form.corporateAddress2 = data_parser_1.default.toHankaku(this.form.corporateAddress2);
                            this.form.corporateAddress3 = data_parser_1.default.toHankaku(this.form.corporateAddress3);
                        }
                        this.form.tel = data_parser_1.default.parseTell(this.form.tel);
                        this.form.officeNo = data_parser_1.default.toHankaku(this.form.officeNo);
                        this.$emit('submit-complete', { component: 'officeInfo', data: this.form });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], OfficeInfo.prototype, "email", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OfficeInfo.prototype, "getMessage", void 0);
    __decorate([
        vue_property_decorator_1.Watch('email')
    ], OfficeInfo.prototype, "emailChange", null);
    OfficeInfo = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ValidationProvider: vee_validate_1.ValidationProvider,
                ValidationObserver: vee_validate_1.ValidationObserver
            }
        })
    ], OfficeInfo);
    return OfficeInfo;
}(vue_property_decorator_1.Vue));
exports.default = OfficeInfo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contract_form/OfficeInfo.vue
// module id = 6Hlx
// module chunks = 1